import"./Badge.css.ts.vanilla.css";var o="var(--_18ovjxl1)",r="var(--_18ovjxl0)",a="_18ovjxl2";export{o as badgeBgColor,r as badgeColor,a as badgeStyle};
